// import { v4 as uuidv4 } from 'uuid';
import cogoToast from 'cogo-toast';
import api from './apiURL';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// Get All Cart Data
export const getCartData = createAsyncThunk(
    'newCart/getCartData',
    async (_, thunkAPI) => {
      
      const { rejectWithValue } = thunkAPI;
  
      try {
        const res = await fetch( api + '/api/v1/cart', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const data = await res.json();
        return data;
        
      } catch (error) {
        console.log(error);
        
        return rejectWithValue(error.message);
      }
    }
);

// Add To Cart
export const addRemoveCart = createAsyncThunk(
    'newCart/addRemoveCart',
    async (productData, thunkAPI) => {
      
      const { rejectWithValue } = thunkAPI;
     
  
      try {
        const res = await fetch( api + '/api/v1/cart', {
          method: 'POST',
          body: JSON.stringify(productData),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const data = await res.json();
        return data;
        
      } catch (error) {
        console.log(error);
        return rejectWithValue(error.message);
      }
    }
);

// clear Cart
export const clearCart = createAsyncThunk(
  'newCart/clearCart',
  async (_, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/reset-products', {
        method: 'POST',
        // body: JSON.stringify(productData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);


// Get Checkout Data
export const getCheckoutData = createAsyncThunk(
  'newCart/getCheckoutData',
  async (_, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/checkout', {
        method: 'GET',
        // body: JSON.stringify(productData),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Set Shipping Data
export const setShippingMethod = createAsyncThunk(
  'newCart/setShippingMethod',
  async (shippingMethodId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/shipping-method', {
        method: 'POST',
        body: JSON.stringify(shippingMethodId),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Set Payment Data
export const setPaymentMethod = createAsyncThunk(
  'newCart/setPaymentMethod',
  async (paymentMethodId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/payment-method', {
        method: 'POST',
        body: JSON.stringify(paymentMethodId),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);


// Set Address Data
export const setAddress = createAsyncThunk(
  'newCart/setAddress',
  async (addressId, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/address', {
        method: 'POST',
        body: JSON.stringify(addressId),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

// Checkout Request
export const checkoutRequest = createAsyncThunk(
  'newCart/checkoutRequest',
  async (_, thunkAPI) => {
    
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await fetch( api + '/api/v1/cart/checkout', {
        method: 'POST',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      return data;
      
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

const NewCartSlice = createSlice({
    name: "newCart",
    initialState: {
        cartLoading: false,
        error: null,
        NewCartItems: [],
        checkoutData: {},
        cartInfo: {},
        orderId: "",
    },
    extraReducers: {
      [getCartData.pending]: (state, action) => {
          state.loading = true;
          state.error = null;
      },
      [getCartData.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              // state.cartItems = action.payload;
          }else{
              state.NewCartItems = action.payload.products;
              state.cartInfo = action.payload;
              // cogoToast.success("Cart Success", {position: "bottom-left"});
              
          }
      },
      [getCartData.rejected]: (state, action) => {
          state.error = action.payload;
          console.log(localStorage.getItem("token"));
      },


      [addRemoveCart.pending]: (state, action) => {
          state.cartLoading = true;
          state.error = null;
      },
      [addRemoveCart.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              // state.cartItems = action.payload;
              state.cartLoading = false;
          }else{
              state.NewCartItems = action.payload.products;
              state.cartLoading = false;
              // cogoToast.success("Cart Add/Remove Success", {position: "bottom-left"});
              
          }
      },
      [addRemoveCart.rejected]: (state, action) => {
          state.error = action.payload;
      },


      [clearCart.pending]: (state, action) => {
        state.cartLoading = true;
        state.error = null;
      },
      [clearCart.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              // state.cartItems = action.payload;
              state.cartLoading = false;
          }else{
              state.NewCartItems = action.payload.products;
              state.cartLoading = false;
              cogoToast.success("Cart Cleared Successfully", {position: "bottom-left"});
              
          }
      },
      [clearCart.rejected]: (state, action) => {
          state.error = action.payload;
      },

      // Get Checkout Data
      [getCheckoutData.pending]: (state, action) => {
      
        state.error = null;
      },
      [getCheckoutData.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              
          }else{
              state.checkoutData = action.payload;
          }
      },
      [getCheckoutData.rejected]: (state, action) => {
          state.error = action.payload;
      },


      // Set Shipping Data
      [setShippingMethod.pending]: (state, action) => {
      
        state.error = null;
      },
      [setShippingMethod.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              
          }else{
            cogoToast.success("Shipping Method Updated", {position: "bottom-left"});
          }
      },
      [setShippingMethod.rejected]: (state, action) => {
          state.error = action.payload;
      },


      // Set Payment Data
      [setPaymentMethod.pending]: (state, action) => {
      
        state.error = null;
      },
      [setPaymentMethod.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              
          }else{
            cogoToast.success("Payment Method Updated", {position: "bottom-left"});
          }
      },
      [setPaymentMethod.rejected]: (state, action) => {
          state.error = action.payload;
      },

      // Set Address Data
      [setAddress.pending]: (state, action) => {
      
        state.error = null;
      },
      [setAddress.fulfilled]: (state, action) => {
          if (action.payload.success === false){
              
          }else{
            cogoToast.success("Shipping Address Updated", {position: "bottom-left"});
          }
      },
      [setAddress.rejected]: (state, action) => {
          state.error = action.payload;
      },


      // Checkout Request
      [checkoutRequest.pending]: (state, action) => {
      
        state.error = null;
      },
      [checkoutRequest.fulfilled]: (state, action) => {
          if (action.payload.success === false){
            cogoToast.error("Error In Checkout", {position: "bottom-left"});
            
          }else{
            cogoToast.success("Order Placed Successfully", {position: "bottom-left"});
            console.log(action.payload);
            state.orderId = action.payload.orderId;
          }
      },
      [checkoutRequest.rejected]: (state, action) => {
          state.error = action.payload;
          cogoToast.error("Error In Checkout", {position: "bottom-left"});
      },
    }

});

// export const { addToCart, deleteFromCart, decreaseQuantity, deleteAllFromCart } = cartSlice.actions;
export default NewCartSlice.reducer;